import { IAppState } from 'src/store/types';

export const getPlacementViewConfig = (state: IAppState) => state.placementViewConfig;
